var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Slider } from "@mui/material";
var UISlider = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 140 : _b, sx = _a.sx, sxBox = _a.sxBox, props = __rest(_a, ["width", "sx", "sxBox"]);
    return (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", width: "100%", p: 1, sx: __assign({}, sxBox), children: _jsx(Slider, __assign({}, props, { step: 1, sx: __assign({ width: width, height: 8, p: 0, "& .MuiSlider-track": {
                    backgroundColor: "rgb(255, 184, 1)",
                    borderColor: " rgba(255, 231, 12, 0.49) ",
                }, "& .MuiSlider-thumb": {
                    width: 16,
                    height: 16,
                    backgroundColor: "rgb(255, 212, 48)",
                    transition: "box-shadow 0.2s, border 0.2s",
                    border: "1px solid rgb(255, 184, 1) ",
                    "&:hover, &.Mui-focusVisible": {
                        boxShadow: "rgba(255, 231, 12, 0.49) 0px 4px 8px -4px; ",
                        border: "1px solid rgba(255, 231, 12, 0.49)",
                    },
                }, "& .MuiSlider-rail": {
                    backgroundColor: "#454444",
                } }, sx) })) }));
};
export default UISlider;
